import {createRootContextHook} from 'common/util/react';

/** Note: this will not include workspace users (for efficiency) */
export const useCurrentUser = createRootContextHook(`currentUser`);
